// Import React for creating the Hero component
import React from "react";
// Import the CSS file for hero section styling
import "../../css/Hero.css";
// Import the reusable Button component
import Button from "./Button";

// Helper function to render multi-line text with line breaks
const renderLines = (text) => {
  const lines = text.split("\n");
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};

// Hero component displays a banner section with title, subtitle, background image, and optional button
// Props:
// - title: Main heading text (supports multi-line)
// - subtitle: Subheading text (supports multi-line)
// - backgroundImage: URL for the background image
// - titleAlign: Alignment for the title ('center' or 'left')
// - subtitleAlign: Alignment for the subtitle ('center' or 'left')
// - buttonText: Text for the optional button
// - onButtonClick: Click handler for the button
function Hero({
  title = "",
  subtitle = "",
  backgroundImage = "",
  titleAlign = "center", // "center" | "left"
  subtitleAlign = "center", // "center" | "left"
  buttonText = "",
  onButtonClick,
}) {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          {/* Render the main title with alignment and line breaks */}
          <h1 className="font-hero-title" style={{ textAlign: titleAlign }}>
            {renderLines(title)}
          </h1>

          {/* Decorative divider under the title */}
          <div className={`divider align-${titleAlign}`}></div>

          {/* Render the subtitle with alignment and line breaks */}
          <p style={{ textAlign: subtitleAlign }}>{renderLines(subtitle)}</p>

          {/* Optional button if buttonText is provided */}
          {buttonText && (
            <Button
              text={buttonText}
              variant="primary"
              onClick={onButtonClick}
            />
          )}
        </div>
      </div>
    </section>
  );
}

// Export the Hero component as default
export default Hero;
